import MLoader from './m-loader.vue';

export default MLoader;
